import * as i0 from '@angular/core';
import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as i1 from '@angular/cdk/layout';

// not global service
class BriMatchMediaService {
    mediaMatcher;
    isDarkThemeSubject = new BehaviorSubject(false);
    _isDarkTheme$ = this.isDarkThemeSubject.asObservable();
    mediaQueryList;
    constructor(mediaMatcher, query = '(prefers-color-scheme: dark)') {
        this.mediaMatcher = mediaMatcher;
        this.mediaQueryList = this.mediaMatcher.matchMedia(query);
        // send the current value
        this.isDarkThemeSubject.next(this.mediaQueryList?.matches);
        this.initEventLister();
    }
    get isDarkTheme$() {
        return this._isDarkTheme$;
    }
    initEventLister() {
        this.mediaQueryList?.addEventListener('change', () => {
            if (this.mediaQueryList) {
                this.isDarkThemeSubject.next(this.mediaQueryList?.matches);
            }
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BriMatchMediaService, deps: [{ token: i1.MediaMatcher }, { token: 'query' }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BriMatchMediaService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BriMatchMediaService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.MediaMatcher }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['query']
                }] }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { BriMatchMediaService };
